import { render, staticRenderFns } from "./BrandSelector.vue?vue&type=template&id=31d96f0c&scoped=true&"
import script from "./BrandSelector.vue?vue&type=script&lang=js&"
export * from "./BrandSelector.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelector.vue?vue&type=style&index=0&id=31d96f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d96f0c",
  null
  
)

export default component.exports